<template>
  <div
    v-if="products"
    class="retail-connect-unavailable-products-fi"
  >
    <retail-connect-unavailable-product-fi
      v-for="(product, index) in visibleProducts"
      :key="index"
      :product="product"
      class="retail-connect-unavailable-products-fi__product"
    />

    <template v-if="isExpandable">
      <slide-up-down-fi
        :model-value="isExpanded"
        :duration="700"
        class="retail-connect-unavailable-products-fi__expanded-products"
      >
        <retail-connect-unavailable-product-fi
          v-for="(product, index) in hiddenProducts"
          :key="index"
          :product="product"
          class="retail-connect-unavailable-products-fi__product"
        />
      </slide-up-down-fi>

      <div class="retail-connect-unavailable-products-fi__expand">
        <span
          class="retail-connect-unavailable-products-fi__expand-text"
          @click="isExpanded = !isExpanded"
        >
          {{
            isExpanded
              ? $dict.get('product-Catalog.Retail.Availability.Reduce-Text')
              : $dict.get('product-Catalog.Retail.Availability.Expand-Text', [
                  hiddenProducts.length,
                ])
          }}
        </span>
      </div>
    </template>
  </div>
</template>

<script>
import { SlideUpDownFi } from 'atoms';

import RetailConnectUnavailableProductFi from './RetailConnectUnavailableProductFi';

export default {
  name: 'RetailConnectUnavailableProductsFi',
  components: {
    SlideUpDownFi,
    RetailConnectUnavailableProductFi,
  },
  props: {
    products: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isExpanded: false,
      visibileItems: 4,
    };
  },
  computed: {
    isExpandable() {
      return this.products.length > this.visibileItems;
    },
    visibleProducts() {
      const vProducts = [...this.products];
      return vProducts.slice(0, this.visibileItems);
    },
    hiddenProducts() {
      const hProducts = [...this.products];
      return hProducts.splice(this.visibileItems);
    },
  },
};
</script>

<style scoped lang="scss">
@import './retail-connect-unavailable-products-fi';
</style>
